import Homepage from '../resources/users';
import {filter} from '../utility/url';

class HomepageController extends Homepage {
    constructor(pattern, data) {
        super(pattern, data);
    }
    
    index() {
        request.onLocal.url.forEach((url, key) => {
            filter(url, this.pattern).then(status => {
                if (status == true) {
                    this[request.onLocal.action[key]]();
                }
                //console.log(status, url);
            });
        });
        
        request.onRepo.url.forEach((url, key) => {
            filter(url, this.pattern).then(status => {
                if (status == true) {
                    this[request.onRepo.action[key]]();
                }
                //console.log(status, url);
            });
        });
    }
}

const request = {
    onLocal: {
        url: [
            "/home/",
            "/home/index.html",
            "/home/logout.html"
        ],
        action: [
            "getComponent",
            "getComponent",
            "logout"
        ]
    },
    onRepo: {
        url: [
            "/portofolio/home/",
            "/portofolio/home/index.html",
            "/portofolio/home/logout.html"
        ],
        action: [
            "getComponent",
            "getComponent",
            "logout"
        ]
    }
};

export default HomepageController;